import React, { useEffect } from 'react';
import { useRoute, Link } from 'wouter';

export const BackLink = (props) => {
    return (
        <Link {...props} asChild>
            <a className={props.className + ' active'}>
                <svg
                    className="links__svg"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 45 45"
                >
                    <g fill="none" fillRule="evenodd">
                        <path
                            stroke="#000"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            className="chevron"
                            d="M26 13 16 23l10 10"
                        />
                    </g>
                </svg>
                <span>{props.children}</span>
            </a>
        </Link>
    );
};
export default BackLink;
